import React from "react";
import Scale from "./assets";
import Hazard from "./assets/hazard-black.svg";
import Error from "./assets/error.svg";
import Success from "./assets/success.svg";
import ZeroButton from "./ZeroButton";
import Table, { Row } from "./Table";
import classes from "./styles.module.scss";
import { useElectronicBalance, ElectronicScaleModalReducer } from "./store";
import { useDispatch } from "react-redux";
import { useSimulation } from "@learningblocks/simulation-engine";
import { CloseButton, FullscreenModal } from "../FullscreenModal";

type ModalProps = {
  image?: string;
  title?: string;
  subtitle?: string;
  hint?: string;
  componentID?: number;
  isOpen: boolean;
  notebookCollapsed: boolean;
  onClose: () => void;
};

const ElectronicScale = ({
  isOpen,
  notebookCollapsed,
  title,
  subtitle,
  hint,
  onClose,
  componentID,
}: ModalProps) => {
  const dispatch = useDispatch();
  const { scaleState, scaleTable, scaleTableFeedback, scaleWeight } =
    useSimulation() as {
      scaleState: string;
      scaleTable: { rows: Row[] };
      scaleWeight: number;
      scaleTableFeedback?: { message: string; type: "success" | "error" };
    };
  const { actions } = useElectronicBalance(dispatch);

  return (
    <FullscreenModal
      altText="We focus on the scale. In the table below, click the “Record” button to read and record the mass."
      isOpen={isOpen}
      notebookExpanded={!notebookCollapsed}
      close={onClose}
      className={classes.bg}
    >
      <div>
        <CloseButton close={onClose} className={classes.back} backLabel="Lab" />
      </div>
      <div className={classes.modal}>
        <div className={classes.container}>
          <div className={classes["left-column"]}>
            <div className={classes.content}>
              <h1>{title}</h1>
              <p>{subtitle}</p>
              {scaleTable && (
                <Table {...scaleTable} componentID={componentID ?? 0} />
              )}
              <div className={classes.footer}>
                <div className={classes.footerHeading}>
                  <img src={Hazard} alt="" />
                  Double check
                </div>
                <div className={classes.footerContent}>{hint}</div>
                {scaleTableFeedback && (
                  <div
                    className={`${classes.footerWarning} ${scaleTableFeedback.type} `}
                  >
                    <span>{scaleTableFeedback.message}</span>
                    <img
                      src={
                        scaleTableFeedback.type === "success" ? Success : Error
                      }
                      alt=""
                    />
                  </div>
                )}
              </div>
            </div>
          </div>
          <div className={classes["right-column"]}>
            <div className={classes.scale}>
              <img src={scaleState || Scale.image} alt="Scale" />
              <ZeroButton onClick={actions.zeroAction} />
              <div className={classes["text-container"]}>
                <div className={classes.text}>
                  {scaleWeight.toFixed(2) + " g"}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </FullscreenModal>
  );
};

export { ElectronicScaleModalReducer };

export default ElectronicScale;
